import Ajax from '@/js/Ajax'
import Tool from '@/js/Tool'
import Config from './Config'

export default {
  GetUserId() {
    return new Promise((resolve, reject) => {
      if (process.env.NODE_ENV == 'development') {
        resolve('19901062')
      } else {
        if (Tool.ss.Get(Config.LoginToken)) {
          resolve('')
        } else {
          var code = Tool.getQueryString('code')
          if (code) {
            resolve(code)
            // Ajax.Get("/api/Login/GetUserByCode/" + Config.LoginAppId + "?code=" + code).then((res) => {
            //   if (res.data) {
            //     resolve(res.data)
            //   } else {
            //     reject();
            //   }
            // }).catch((err) => {
            //   Tool.Phone.alert(err.message).then(() => {
            //     reject();
            //   });
            // });
          } else {
            var reurl = window.location.href
            var url =
              'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' +
              Config.AppId +
              '&redirect_uri=' +
              encodeURI(reurl) +
              '&response_type=code&scope=snsapi_base&state=STATE#wechat_redirect'
            window.location.replace(url)
            setTimeout(() => {
              resolve()
            }, 1000)
          }
        }
      }
    })
  },
  GetCodeUser(code) {
    return new Promise((resolve, reject) => {
      Ajax.Get(
        '/api/Login/GetUserByCode/' + Config.LoginAppId + '?code=' + code
      ).then((res) => {
        if (res.data) {
          resolve(res.data)
        } else {
          reject()
        }
      })
    })
  },
}
